const callMeHelper = {
  updateChat: async function (callMe, callMeService, recurrentUpdate, context, segment = 'Regular', config) {
    if (recurrentUpdate) {
      callMe = await callMeService.getCallMeSchedule(context.props.tenant, context.props.locale, segment, config)
    }
    if (callMe?.status) {
      context.setState({
        remainingTime: recurrentUpdate ? callMe.status.remainingTime : context.state.ttl, // case where button changed: remaining time expired and should have a default value again
        ttl: recurrentUpdate ? callMe.status.TTL : context.state.ttl,
      })
      if (recurrentUpdate) {
        context.setState({
          callMeOpen: callMe.status.isScheduleOpen,
          callMeDisabled: !callMe.status.isFeatureEnabled,
          businessHours: callMe.businessHours,
        })
      } else {
        context.setState({
          callMeOpen: !callMe.status.isScheduleOpen,
          callMeDisabled: callMe.status.isFeatureEnabled,
          businessHours: callMe.businessHours,
        })
      }
    }
  },
  formatSchedule: function (businessHours) {
    const formattedSchedules = []
    businessHours?.schedule?.length &&
      businessHours.schedule.forEach(function (item, index) {
        if (formattedSchedules.length === 0) {
          formattedSchedules.push({ startDay: item.weekday, endDay: item.weekday, startTime: item.startTime, endTime: item.endTime })
        } else {
          const previousItem = formattedSchedules[formattedSchedules.length - 1]
          if (previousItem.startTime === item.startTime && previousItem.endTime === item.endTime) {
            formattedSchedules[formattedSchedules.length - 1].endDay = item.weekday
          } else {
            formattedSchedules.push({ startDay: item.weekday, endDay: item.weekday, startTime: item.startTime, endTime: item.endTime })
          }
        }
      })
    return formattedSchedules
  },
}

export default callMeHelper
